import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Garante que a rolagem retorne ao topo em qualquer mudança de rota,
 * evitando que o usuário caia no rodapé ou no espaço escuro ao navegar.
 */
export function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, search]);

  return null;
}
